// Utility to fetch an image from public folder and convert to base64
async function getBase64FromPublicImage(imagePath) {
  const response = await fetch(imagePath);
  const blob = await response.blob();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

// Sends a dummy ID scan using padde.png from public folder
async function sendDummyIdScan() {
  try {
    // Get deviceId from URL token parameter
    const urlParams = new URLSearchParams(window.location.search);
    const deviceId = urlParams.get('token') || 'DEVICE001';
    
    const base64Image = await getBase64FromPublicImage('/padde.png');
    const idScanData = {
      deviceId: deviceId,
      ageDetected: 31,
      securityCheckPassed: true,
      securityChecksWithSuccess: 2,
      securityChecksWithError: 0,
      countryDetected: 'AUT',
      countryLongDetected: 'Austria',
      userIp: '192.168.1.100',
      portraitBase64: base64Image
    };
    const response = await fetch('https://api-main.ageverification.at/readerApi/submitReaderData', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify(idScanData)
    });
    const result = await response.json();
    console.log("RESULT ", result);
    return result;
  } catch (error) {
    console.error('Dummy ID scan error:', error);
    throw error;
  }
}

// Export to global scope for browser debug console
if (typeof window !== 'undefined') {
  window.sendDummyIdScan = sendDummyIdScan;
}

export { sendDummyIdScan };